import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DestinoService} from '../../core/services/destino.service';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-hoteis',
    templateUrl: './hoteis.component.html',
    styleUrls: ['./hoteis.component.sass']
})
export class HoteisComponent extends BaseComponents implements OnInit {

    resultHoteis: any;

    constructor(
        protected injector: Injector,
        protected titleService: Title,
        protected meta: Meta,
        public destinoService: DestinoService,
        protected router: Router) {
        super(injector);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    ngOnInit() {
        this.loadHoteis();
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.HOTEIS);
    }

    async loadHoteis() {

        this.resultHoteis = await this.destinoService.listaDestinos();
    }

    public irParaDestino(slug) {
        this.router.navigate(['/destinos', slug]);
    }
}
